import request from "../utils/request";

// 运营中心数据
export function getOperateData(data) {
  return request({
    method: "get",
    url: "/index/get_YL_Table_ByShop_list",
    params: {
      limit: "all",
      ...data,
    },
  });
}

// 详情折线图数据
export function getOperateLineChart(data) {
  return request({
    method: "get",
    url: "/index/get_YL_LineChart_ByShop_list",
    params: { limit: "all", ...data },
  });
}

// 详情市场动态
export function getRegionMarket(data) {
  return request({
    method: "get",
    url: "/index/get_YL_Market_ByRegion_list",
    params: { limit: "all", ...data },
  });
}

// 详情饼图
export function getRegionPie(data) {
  return request({
    method: "get",
    url: "/index/get_VIP_PieChart_ByShop_list",
    params: { limit: "all", ...data },
  });
}

// 详情VIP信息
export function getVipInfo(data) {
  return request({
    method: "get",
    url: "/index/get_VIP_Table_ByShop_list",
    params: { limit: "all", ...data },
  });
}
